import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import { DownloadableReport, useXLSXGenerator } from "../../../hooks/useXLSXGenerator";

const useStyle = makeStyles((theme) => ({
  downloadButton: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    padding: "16px 16px",
    height: "40px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      height: "40px",
      color: theme.palette.text.primary,
      transform: "none",
    },
  },
}));

interface ReportDownloadButtonProps {
  report: DownloadableReport;
}

export const ReportDownloadButton = (props: ReportDownloadButtonProps) => {
  const classes = useStyle();
  const { report } = props;
  const generateXLSX = useXLSXGenerator();
  const handleClick = () => {
    generateXLSX(report);
  };

  return (
    <Button
      onClick={handleClick}
      size="medium"
      className={classes.downloadButton}
      variant="contained"
      endIcon={<i className="fa-solid fa-download"></i>}>
      Download
    </Button>
  );
};
